Util = require 'lib/util'
Tooltip = require 'views/lib/tooltip'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class HeaderBackButtonView extends View

  className: 'header-back-button'

  events:
    'click .js-back-menu': 'backPressed'
    'mouseenter .js-back-menu': 'showTooltip'
    'mouseleave .js-back-menu': 'hideTooltip'

  render: ->

    @$el.html(
      templates.fill(
        'header_back_menu_button'
      )
    )

    @

  backPressed: ->
    track("Header", "Back to Home Menu", "Clicked")

  showTooltip: ->
    $btn = @$('.js-back-menu')
    Tooltip.show($btn.attr('aria-label'), $btn, false, Tooltip.STYLE.MENU)

  hideTooltip: ->
    Tooltip.hide()



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-back-button-view.coffee